/*
 * @Author: liyxt
 * @Date: 2020-05-06 14:00:41
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:51:55
 * @Description: file content
 */ 
//import Message from 'bee-message';
import { Message } from '@tinper/next-ui';

//require('bee-message/build/Message.css');
//require('./index.less');

export default Message;
